export enum RedirectStoreTypes {
  Shopify = 'shopify',
  BigCommerce = 'bigcommerce',
  Ebay = 'ebay',
}
